module.exports = __webpack_public_path__ + "img/imagen11.b62fbe33.jpg";